import { render } from "./MessageLoading.vue?vue&type=template&id=e6b4c236&scoped=true"
import script from "./MessageLoading.vue?vue&type=script&lang=js"
export * from "./MessageLoading.vue?vue&type=script&lang=js"

import "./MessageLoading.vue?vue&type=style&index=0&id=e6b4c236&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6b4c236"],['__file',"src/components/MessageLoading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e6b4c236"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e6b4c236', __exports__)) {
    api.reload('e6b4c236', __exports__)
  }
  
  module.hot.accept("./MessageLoading.vue?vue&type=template&id=e6b4c236&scoped=true", () => {
    api.rerender('e6b4c236', render)
  })

}


export default __exports__